<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">产品管理</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label  DeviceInfos">
                <el-tabs>
                  <el-tab-pane label="修改产品">
                    <el-form ref="form" :model="form" label-width="100px"  v-loading="loading">
                      <el-form-item label="产品标题：">
                        <el-input placeholder="请输入产品标题" v-model="form.title"></el-input>
                      </el-form-item>
                      <el-form-item label="产品价格：">
                        <div style="width: 30%;" class="iptmy">
                          <el-input placeholder="请输入产品价格" v-model="form.money" :disabled="moneystatus"
                          onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                          maxlength="8">
                            <template slot="append"><el-checkbox v-model="checked" @change="my()">面议</el-checkbox></template>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item label="产品分类：">
                        <!-- <el-select clearable v-model="form.cid" placeholder="选择产品分类" class="news-select">
                          <el-option  v-for="(item, index) in type" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select> -->
                        <div style="width: 30%;" class="iptmy">
                          <el-cascader
                            v-model="value"
                            :options="type"
                            :props="{ expandTrigger: 'hover' }"
                            @change="handleChange"></el-cascader>
                        </div>
                      </el-form-item>
                      <el-form-item label="产品封面：" >
                          <el-upload
                            class="avatar-uploader"
                            action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                          <p class="Upload_pictures">
                              <span></span>
                              <span>建议尺寸390*274、只能是JPG、png、JEpg格式且不超过2M</span>
                          </p>
                      </el-form-item>

                      <el-form-item label="产品视频：" >
                          <div class="pic_img">
                              <div class="pic_img_box">
                                  <el-upload class="avatar-uploader"
                                             action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcordssp"
                                             v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                                             v-bind:on-progress="uploadVideoProcess"
                                             v-bind:on-success="handleVideoSuccess"
                                             v-bind:before-upload="beforeUploadVideo"
                                             v-bind:show-file-list="false">
                                      <video v-if="videoForm.showVideoPath !='' && !videoFlag"
                                             v-bind:src="videoForm.showVideoPath"
                                             class="avatar video-avatar avatars"
                                             controls="controls">
                                          您的浏览器不支持视频播放
                                      </video>
                                      <i v-else-if="videoForm.showVideoPath =='' && !videoFlag"
                                         class="el-icon-plus avatar-uploader-icon"></i>
                                      <el-progress v-if="videoFlag == true"
                                       type="circle"
                                       v-bind:percentage="videoUploadPercent"
                                       style="margin-top:7px;"></el-progress>
                                  </el-upload>
                              </div>
                          </div>
                          <p class="Upload_pictures">
                              <span></span>
                              <span>最多可以上传1个视频，建议大小100M，推荐格式mp4</span>
                          </p>
                      </el-form-item>


                      <el-form-item label="产品简介：" >
                        <el-input
                          class="textarea-ipt"
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 6}"
                          placeholder="请输入产品简介"
                          v-model="form.introduction">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="产品描述" ></el-form-item>
                      <quill-editor
                        v-model="form.content"
                        ref="myQuillEditor"
                        :options="quillOption"
                      >
                      </quill-editor>
                      <div class="h-30"></div>
                      <p class="Upload_pictures">
                          <span></span>
                          <span>建议单图上传5M以内产品图</span>
                      </p>
                      <div class="h-20"></div>
                      <el-form-item>
                        <el-button type="primary" @click="onSubmit(form)" size="medium">确定</el-button>
                      </el-form-item>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="h-30"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>
<style>
   .avatars{width: 345px;height: 196px;display: initial;}
  .ql-editor{height: 200px;}
</style>
<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
// 富文本编辑器
import { quillEditor } from 'vue-quill-editor'
import quillConfig from '../../static/js/quill-config.js'
export default{
  data(){
    return {
     loading:true,
     activeIndex: '3',
     imageUrl: '',
     checked: false,
     moneystatus:false,
     type:[],
     form: {
         title: '',
         cid:'',
         money:'',
         content:'',
         picurl:'',
         introduction:'',
         sp:'',
     },
     id:'',
     quillOption: quillConfig,

     // 上传视频
     videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
     			  showVideoPath: ''
      },
      value:[],


    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,

  },
  mounted(){
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{
    handleChange(value) {
      this.form.cid = value[1];
      console.log(this.form.cid);
    },
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        console.log(that.id);
        that.$api.post("/Member/MemberProducteditlist",{'userid':userid,'id':that.id}).then(res => {
          console.log(res);
          if(res.code == 1){
            that.type= res.type;
            that.form= res.form;
            that.value= res.form.value;
            this.imageUrl = res.form.picurl;
            this.videoForm.showVideoPath = res.form.sp;
            if(res.form.money==0.00){
              that.checked = true;
              that.moneystatus = true;
            }
             this.loading = false
          }


        });
    },


    // 图片
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.picurl = res.path;
    },
    //
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        // const isJPG = file.type = ['image/jpeg', 'image/jpg', 'image/png'];
        const isLt2M = file.size / 1024 / 1024 < 10;

        // if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        //   this.$message.error('上传头像图片只能是 JPG,jpeg,png 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isLt2M;
    },
    my:function(){
      var that = this;
      console.log(this.checked);
      if(that.checked==true){
        that.moneystatus = true;
        this.form.money = 0;
      }else{
        that.moneystatus = false;
      }
    },

    onSubmit(form){
      console.log(form);
      console.log(this.form.content);
      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      that.form.userid = userid;
      that.form.id = that.id;
      console.log(this.form);
      that.$api.post("/Member/MemberProductEdit",{data:this.form}).then(res => {
        console.log(res);
        this.$message.success(res.msg);
        // that.form.title = '';
        // that.form.cid = '';
        // that.form.money = '';
        // that.form.content = '';
        // that.form.picurl = '';
        // that.imageUrl="";
        // that.moneystatus = false;
        // that.checked = false;
      });
    },

    //上传前回调
    beforeUploadVideo(file) {
        var fileSize = file.size / 1024 / 1024 < 100;
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
           this.$message.error("请上传正确的视频格式");
            return false;
        }
        if (!fileSize) {
            this.$message.error("视频大小不能超过100MB");
            return false;
        }
        this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
        this.videoFlag = true;
        this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
        this.isShowUploadVideo = true;
        this.videoFlag = false;
        this.videoUploadPercent = 0;

        //前台上传地址
        //if (file.status == 'success' ) {
        //    this.videoForm.showVideoPath = file.url;
        //} else {
        //     layer.msg("上传失败，请重新上传");
        //}

        //后台上传地址
        if(res.code == 0){
          this.videoForm.showVideoPath = res.data;
          this.sp = res.path;
        }else{
            // layer.msg(res.Message);
            console.log(res);
        }
    }



  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberProductEdit.vue